import React, { useRef, useEffect, useState } from 'react';

// Fallback cn utility if you're not using Tailwind's clsx/cn helper
function cn(...classes) {
  return classes.filter(Boolean).join(' ');
}

const FAQItem = ({
  question,
  answer,
  isExpanded,
  isFirst = false,
  onToggle
}) => {
  const contentRef = useRef(null);
  const [maxHeight, setMaxHeight] = useState('0px');

  useEffect(() => {
    if (contentRef.current) {
      setMaxHeight(isExpanded ? `${contentRef.current.scrollHeight}px` : '0px');
    }
  }, [isExpanded]);

  return (
    <div className="flex flex-col">
      {!isFirst && (
        <div
          className={cn(
            "h-px bg-[#6D7E94] transition-all duration-300 ease-in-out",
            isExpanded ? "w-full" : (isFirst ? "w-[667px]" : "w-[136px]"),
            "max-sm:w-full"
          )}
        />
      )}

      <div
        className="flex items-center gap-3 cursor-pointer px-0 py-5 max-sm:py-4 max-sm:gap-2"
        onClick={onToggle}
        role="button"
        aria-expanded={isExpanded}
      >
        <div
          className={cn(
            "flex-1 text-base font-semibold leading-6 overflow-hidden",
            "max-sm:text-sm max-sm:leading-5",
            isExpanded ? "text-[#966376]" : "text-[#1D1E1C]"
          )}
        >
          {question}
        </div>
        <div className="shrink-0">
          <svg
            width="32"
            height="32"
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className="max-sm:w-6 max-sm:h-6"
            style={{
              transform: isExpanded ? 'rotate(180deg)' : 'rotate(0deg)',
              transition: 'transform 0.2s ease-in-out'
            }}
          >
            <path
              d="M16 4C9.37259 4 4 9.37258 4 16C4 22.6274 9.37258 28 16 28C22.6274 28 28 22.6274 28 16C28 9.37258 22.6274 4 16 4Z"
              stroke={isExpanded ? "#966376" : "#1D1E1C"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M11 14L16 19L21 14"
              stroke={isExpanded ? "#966376" : "#1D1E1C"}
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>
      </div>

      {/* Animated Answer Section */}
      <div
        ref={contentRef}
        style={{
          maxHeight,
          overflow: 'hidden',
          transition: 'max-height 0.3s ease, opacity 0.3s ease',
          opacity: isExpanded ? 1 : 0,
        }}
      >
        <div className="text-[#1D1E1C] text-base font-normal leading-[28.8px] mb-4 pr-12 max-sm:pr-0 max-sm:text-sm max-sm:leading-6">
          {Array.isArray(answer) ? (
            <ul className="list-disc list-inside space-y-2">
              {answer.map((item, idx) => (
                <li key={idx}>{item}</li>
              ))}
            </ul>
          ) : (
            <p>{answer}</p>
          )}
        </div>
      </div>
    </div>
  );
};

export default FAQItem;
